import  { defineAsyncResource, defineAsyncView, fireEvent, createRestfulAsyncFunction, Mushroom, MushroomError } from "mushroomjs";
import type { IdType, IMushroom, MushroomRequest, MushroomRequestSetting, MushroomRestfulRequest, MushroomResponse, MushroomResponseDataType, MushroomResourceBase, MushroomListResource, MushroomCountResource, MushroomFindByIdResource, MushroomCreateResource, MushroomBatchCreateResource, MushroomUpdateResource, MushroomBatchUpdateResource, MushroomPartialUpdateResource, MushroomDeleteResource, MushroomBatchDeleteResource, MushroomExtensibleResource, MushroomViewFunction, IMushroomOfflineResponse, MushroomOfflineResponse, MushroomOfflineResponseState } from "mushroomjs";
/* import all mushroom extensions */
import config from "../../../src/config.json";
const mushroom = new Mushroom('TrangVang');
import * as AuthExtension from "mushroomjs-auth";
import * as FileExtension from "mushroomjs-file";
export * from "mushroomjs";
export const extensions = {
    /* export all mushroom extensions */
    File: FileExtension,
    Auth: AuthExtension
};

export type ISODateValue = string | Date;
export type IdValue = string;

export interface CustomMethodRequest<TParam extends {}, TBody> extends MushroomRequest {
  params?: TParam;
  body?: TBody;
}

export interface CustomMethodParamsRequest<TParam extends {}> extends MushroomRequest {
  params?: TParam;
}

export interface CustomMethodBodyRequest<TBody> extends MushroomRequest {
  body?: TBody;
}

export interface User {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tài khoản
     */
    account?: string | null;
    /**
     * Mật khẩu
     */
    password?: string | null;
    /**
     * Cho biết tài khoản có bị khóa hay không, nếu bị khóa, tài khoản sẽ không thể đăng nhập được
     */
    disabled?: boolean | null;
    /**
     * Danh sách quyền của người dùng
     */
    roles?: Array<string | null | undefined> | null;
    /**
     * Danh sách các token của người dùng
     */
    tokens?: Array<User_Tokens | null | undefined> | null;
    __no_pwd?: boolean | null;
}

export interface User_Tokens {
    /**
     * Giá trị token
     */
    value?: string | null;
    /**
     * Thời điểm token được tạo
     */
    time?: ISODateValue | null;
}

export interface User$CustomMethodResource {
    registerDestinationUserAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerTicketUserAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<User>({"name":"user","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"_raw_http_method_registerDestinationUser":{},"_raw_http_method_registerTicketUser":{}},"views":{}}, mushroom);

export interface Tv_lien_he {
    id?: IdValue | null;
    /**
     * tên ng đăng ký quảng cáo
     */
    ho_ten?: string | null;
    /**
     * email
     */
    email?: string | null;
    /**
     * Sđt đăng ký quảng cáo
     */
    sdt?: string | null;
    /**
     * tên cty đăng ký quảng cáo
     */
    noi_dung?: string | null;
    creationTime?: ISODateValue | null;
    xu_ly?: boolean | null;
}

defineAsyncResource<Tv_lien_he>({"name":"tv_lien_he","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Profile {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Tên người dùng
     */
    ho_ten?: Profile_Ho_ten | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Mã ảnh đại diện
     */
    avatar_id?: IdValue | null;
    /**
     * Mã công ty lữ hành, doanh nghiệp hoặc tổ chức. Nếu bằng null thì là tài khoản cá nhân
     */
    cong_ty_id?: IdValue | null;
    /**
     * Loại công ty, nhận các giá trị: cong_ty_lu_hanh, doanh_nghiep, to_chuc
     */
    loai_cong_ty?: string | null;
}

export interface Profile_Ho_ten {
    /**
     * Tên
     */
    ten?: string | null;
    /**
     * Họ
     */
    ho?: string | null;
    /**
     * Họ tên đầy đủ
     */
    ho_ten?: string | null;
    /**
     * Định dạng tên
     */
    dinh_dang?: string | null;
}

defineAsyncResource<Profile>({"name":"profile","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{}},"views":{}}, mushroom);

export interface Tv_quang_cao {
    id?: IdValue | null;
    /**
     * Thông tin quảng cáo
     */
    thong_tin?: Tv_quang_cao_Thong_tin | null;
    /**
     * 0: duyệt, 1: chờ duyệt, 2: không duyệt
     */
    trang_thai?: number | null;
    /**
     * có hiển thị quảng cáo này không
     */
    hien_thi?: boolean | null;
    /**
     * Vị trí trang quảng cáo
     */
    vi_tri?: Tv_quang_cao_Vi_tri | null;
    /**
     * chi phí của quảng cáo
     */
    chi_phi?: number | null;
    /**
     * Thời điểm bắt đầu
     */
    thoi_diem_bat_dau?: ISODateValue | null;
    /**
     * thời hạn của quảng cáo
     */
    thoi_diem_ket_thuc?: ISODateValue | null;
    /**
     * Thời gian tạo bản ghi
     */
    creationTime?: ISODateValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    lastModificationTime?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    lastModifierUserId?: IdValue | null;
}

export interface Tv_quang_cao_Thong_tin {
    /**
     * tên ng đăng ký quảng cáo
     */
    ten?: string | null;
    /**
     * sdt
     */
    sdt?: string | null;
    /**
     * tên cty đăng ký quảng cáo
     */
    ten_cong_ty?: string | null;
    /**
     * tên cty đăng ký quảng cáo
     */
    nganh_nghe?: string | null;
    /**
     * tên cty đăng ký quảng cáo
     */
    san_pham_chinh?: string | null;
    /**
     * link duong dan quang cao muon den
     */
    link?: string | null;
    /**
     * nội dung quảng cáo
     */
    noi_dung?: string | null;
    /**
     * id media
     */
    mediaId?: string | null;
    /**
     * Email của công ty muốn quảng cáo
     */
    email?: string | null;
}

export interface Tv_quang_cao_Vi_tri {
    /**
     * Trang hiển thị (Trang chủ, Giới thiệu, Điểm đến, Chi tiết điểm đến, Tour, Chi tiết tour, Lưu trú, Chi tiết lưu trú, Ẩm thực, Chi tiết ẩm thực, Giải trí, Chi tiết giải trí, Vé điện tử, Tin tức, Chi tiết tin tức)
     */
    trang?: string | null;
    /**
     * Vị trí quảng cáo hiển thị
     */
    vi_tri_trang?: string | null;
}

defineAsyncResource<Tv_quang_cao>({"name":"tv_quang_cao","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Diem_den_an_toan {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thông tin duyệt
     */
    duyet?: Diem_den_an_toan_Duyet | null;
    /**
     * Thông tin hoạt động
     */
    hoat_dong?: Diem_den_an_toan_Hoat_dong | null;
    /**
     * Loại điểm đến
     */
    loai_diem_den?: string | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Diem_den_an_toan_Thong_tin_chung | null;
    /**
     * Dữ liệu khai báo khi đăng ký điểm đến an toàn
     */
    du_lieu_khai_bao?: Diem_den_an_toan_Du_lieu_khai_bao | null;
    /**
     * Album ảnh của điểm đến an toàn
     */
    album?: Array<Diem_den_an_toan_Album | null | undefined> | null;
    /**
     * Nội dung hiển thị
     */
    noi_dung_hien_thi?: Array<Diem_den_an_toan_Noi_dung_hien_thi | null | undefined> | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời điểm cập nhật cuối
     */
    thoi_diem_cap_nhat_cuoi?: ISODateValue | null;
    /**
     * Thông tin merchant
     */
    merchant?: Diem_den_an_toan_Merchant | null;
    /**
     * Thông tin khách hàng thân thiết
     */
    bankClient?: Diem_den_an_toan_BankClient | null;
    /**
     * Cho biết điểm đến đã đăng ký Audio Guide hay chưa
     */
    isRegisteredAudio?: boolean | null;
    /**
     * Thông tin điểm đến agm
     */
    agmPlace?: Diem_den_an_toan_AgmPlace | null;
}

export interface Diem_den_an_toan_Duyet {
    /**
     * Cho biết điểm đến đã được duyệt hay chưa
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm điểm đến đã được duyệt
     */
    thoi_diem_duoc_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

export interface Diem_den_an_toan_Hoat_dong {
    /**
     * Cho biết đơn vị có đang ngừng hoạt động hay không. Mặc định là đang hoạt động
     */
    ngung_hoat_dong?: boolean | null;
    /**
     * Thời điểm ngừng hoạt động/hoạt động trở lại (gần nhất) - Do người dùng SafePlace đổi
     */
    thoi_diem_thay_doi_cuoi?: ISODateValue | null;
    /**
     * Lịch sử các lần thay đổi trạng thái hoạt động
     */
    lich_su_thay_doi?: Array<Diem_den_an_toan_Hoat_dong_Lich_su_thay_doi | null | undefined> | null;
}

export interface Diem_den_an_toan_Hoat_dong_Lich_su_thay_doi {
    /**
     * Cho biết có phải trạng thái thay đổi về ngừng hoạt động hay không
     */
    ngung_hoat_dong?: boolean | null;
    /**
     * Thời điểm thay đổi
     */
    thoi_diem?: ISODateValue | null;
    /**
     * Mã người thay đổi
     */
    nguoi_thay_doi_id?: IdValue | null;
}

export interface Diem_den_an_toan_Thong_tin_chung {
    /**
     * Tên điểm đến an toàn
     */
    ten?: string | null;
    /**
     * Mã ảnh đại diện trên hệ thống survey
     */
    anh?: IdValue | null;
    /**
     * Thông tin giấy tờ định danh điểm đến
     */
    giay_to?: Diem_den_an_toan_Thong_tin_chung_Giay_to | null;
    /**
     * Thông tin địa chỉ
     */
    dia_chi?: Diem_den_an_toan_Thong_tin_chung_Dia_chi | null;
    /**
     * Thông tin người đại diện
     */
    nguoi_dai_dien?: Diem_den_an_toan_Thong_tin_chung_Nguoi_dai_dien | null;
    /**
     * Nguồn đăng ký
     */
    nguon?: string | null;
    /**
     * Cho biết điểm đến này có được duyệt trên trang vàng hay không
     */
    trang_vang?: boolean | null;
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi
     */
    gia_tri_uu_dai?: number | null;
    /**
     * Các thông tin cho hướng dẫn viên
     */
    huong_dan_vien?: Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Giay_to {
    /**
     * Mã số thuế/Mã số doanh nghiệp
     */
    so_giay_to?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Danh sách mã ảnh scan
     */
    scan?: Array<IdValue | null | undefined> | null;
    /**
     * Địa chỉ trên đăng ký kinh doanh
     */
    dia_chi?: string | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Dia_chi {
    /**
     * Quốc gia
     */
    quoc_gia?: string | null;
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên tỉnh
     */
    tinh?: string | null;
    /**
     * Mã tỉnh
     */
    tinh_id?: IdValue | null;
    /**
     * Tên huyện
     */
    huyen?: string | null;
    /**
     * Mã huyện
     */
    huyen_id?: IdValue | null;
    /**
     * Tên xa
     */
    xa?: string | null;
    /**
     * Mã xã
     */
    xa_id?: IdValue | null;
    /**
     * Địa chỉ giao dịch
     */
    dia_chi?: string | null;
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Nguoi_dai_dien {
    /**
     * Họ và tên
     */
    ho_ten?: string | null;
    /**
     * Chức vụ
     */
    chuc_vu?: string | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
    /**
     * Số CMT/ Căn cước/ Hộ chiếu
     */
    so_giay_to?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien {
    /**
     * Thông tin ưu đãi
     */
    uu_dai?: Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien_Uu_dai | null;
}

export interface Diem_den_an_toan_Thong_tin_chung_Huong_dan_vien_Uu_dai {
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi
     */
    gia_tri_uu_dai?: number | null;
}

export interface Diem_den_an_toan_Du_lieu_khai_bao {
    /**
     * account của điểm đến
     */
    user_account?: string | null;
}

export interface Diem_den_an_toan_Album {
    /**
     * Ngôn ngữ hiển thị
     */
    ngon_ngu?: string | null;
    /**
     * Id của ảnh hiển thị
     */
    anh_id?: IdValue | null;
    /**
     * Loại ảnh hoặc video
     */
    type?: string | null;
    /**
     * Tiêu đề của ảnh
     */
    tieu_de?: string | null;
}

export interface Diem_den_an_toan_Noi_dung_hien_thi {
    /**
     * Ngôn ngữ hiển thị
     */
    ngon_ngu?: string | null;
    /**
     * Giới thiệu thông tin
     */
    gioi_thieu?: string | null;
    /**
     * Id của ảnh hiển thị
     */
    anh_id?: IdValue | null;
    /**
     * Nội dung hiển thị
     */
    noi_dung?: string | null;
}

export interface Diem_den_an_toan_Merchant {
    /**
     * Callback Url của VpsMerchantCallback
     */
    callbackUrl?: string | null;
    /**
     * Cho biết merchant có ở trạng thái đang xử lý hay không
     */
    processingStatus?: boolean | null;
    /**
     * Cho biết merchant có hiệu lực hay không?
     */
    enabled?: boolean | null;
    /**
     * Merchant Code
     */
    merchantCode?: string | null;
    /**
     * Client Code
     */
    clientCode?: string | null;
    /**
     * SecureKey
     */
    secureKey?: string | null;
    /**
     * Loại hợp đồng đã ký. (none: chưa ký, cert: đã ký chứng chỉ, contact: đã ký hợp đồng)
     */
    signed?: string | null;
}

export interface Diem_den_an_toan_BankClient {
    /**
     * Id của bạn
     */
    id?: string | null;
    /**
     * Key của bạn
     */
    key?: string | null;
    /**
     * Cho biết ký hợp đồng hay chưa
     */
    signed?: boolean | null;
}

export interface Diem_den_an_toan_AgmPlace {
    /**
     * Mã điểm đến agm
     */
    placeCode?: string | null;
    /**
     * Tên điểm đến agm
     */
    placeName?: string | null;
}

export interface Diem_den_an_toan$CustomMethodResource {
    getAccountAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_uu_daiAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_hdv_uu_daiAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    update_album_imageAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Diem_den_an_toan>({"name":"diem_den_an_toan","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_getAccount":{},"_raw_http_method_update_uu_dai":{},"_raw_http_method_update_hdv_uu_dai":{},"_raw_http_method_update_album_image":{}},"views":{}}, mushroom);

export interface Diem_den_an_toan_check_in {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người đến checkin
     */
    nguoi_check_in_id?: IdValue | null;
    /**
     * Mã điểm đến an toàn
     */
    diem_den_an_toan_id?: IdValue | null;
    /**
     * Thời điểm check in
     */
    thoi_diem_check_in?: ISODateValue | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Đối tượng thực hiện checkin
     */
    doi_tuong_thuc_hien?: string | null;
    /**
     * Nguồn phát sinh
     */
    nguon?: string | null;
    /**
     * Thông tin đánh giá
     */
    danh_gia?: Diem_den_an_toan_check_in_Danh_gia | null;
    /**
     * Mã đặt phòng
     */
    booking_no?: string | null;
}

export interface Diem_den_an_toan_check_in_Danh_gia {
    /**
     * Số sao đánh giá của người dùng
     */
    gia_tri?: number | null;
    /**
     * Nội dung đánh giá
     */
    noi_dung?: string | null;
    /**
     * Danh sách các đánh giá thành phần
     */
    thanh_phan?: Array<Diem_den_an_toan_check_in_Danh_gia_Thanh_phan | null | undefined> | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Lưu thông tin thêm của từng đánh giá
     */
    thong_tin_them?: Diem_den_an_toan_check_in_Danh_gia_Thong_tin_them | null;
}

export interface Diem_den_an_toan_check_in_Danh_gia_Thanh_phan {
    /**
     * Mã nhóm thành phần
     */
    nhom_id?: IdValue | null;
    /**
     * Giá trị đánh giá thành phần
     */
    gia_tri?: number | null;
}

export interface Diem_den_an_toan_check_in_Danh_gia_Thong_tin_them {
    /**
     * Thong tin kpi
     */
    kpis?: Array<string | null | undefined> | null;
}

defineAsyncResource<Diem_den_an_toan_check_in>({"name":"diem_den_an_toan_check_in","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Tv_dich_vu_tour {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Tên tour
     */
    ten_tour?: string | null;
    /**
     * Mô tả tour
     */
    mo_ta?: string | null;
    /**
     * Chi tiết tour
     */
    chi_tiet?: string | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Tv_dich_vu_tour_Thong_tin_chung | null;
    /**
     * Hành trình tour
     */
    hanh_trinh?: Tv_dich_vu_tour_Hanh_trinh | null;
    duyet?: Tv_dich_vu_tour_Duyet | null;
    /**
     * id của công ty lữ hành
     */
    cong_ty_lu_hanh_id?: IdValue | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    /**
     * id ảnh đại diện
     */
    mediaId?: string | null;
    /**
     * Danh sách ảnh trong album
     */
    album_anh?: Array<Tv_dich_vu_tour_Album_anh | null | undefined> | null;
    /**
     * Giá trị ưu đãi
     */
    uu_dai?: string | null;
    /**
     * Ngôn ngữ hiển thị. vi - Việt Nam, en - English
     */
    ngon_ngu?: string | null;
    /**
     * Cho biết có muốn hiển thị không
     */
    visible?: boolean | null;
    /**
     * Số lượt xem
     */
    luot_xem?: number | null;
}

export interface Tv_dich_vu_tour_Thong_tin_chung {
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
    /**
     * Đường dẫn bên Traveloka
     */
    url_traveloka?: string | null;
    /**
     * Đường dẫn bên Ivivu
     */
    url_ivivu?: string | null;
    /**
     * Đường dẫn bên Agoda
     */
    url_agoda?: string | null;
    /**
     * Đường dẫn bên Vntrip
     */
    url_vntrip?: string | null;
    /**
     * Đường dẫn bên chudu24
     */
    url_chudu24?: string | null;
    link_dich_vu?: Array<Tv_dich_vu_tour_Thong_tin_chung_Link_dich_vu | null | undefined> | null;
    /**
     * Đường dẫn đến các mạng xã hội
     */
    link_mang_xa_hoi?: Array<Tv_dich_vu_tour_Thong_tin_chung_Link_mang_xa_hoi | null | undefined> | null;
}

export interface Tv_dich_vu_tour_Thong_tin_chung_Link_dich_vu {
    /**
     * id của dịch vụ
     */
    id?: IdValue | null;
    /**
     * Tên dịch vụ
     */
    link?: string | null;
}

export interface Tv_dich_vu_tour_Thong_tin_chung_Link_mang_xa_hoi {
    /**
     * Tên mạng xã hội
     */
    name?: string | null;
    /**
     * Link liên kết mạng xã hội
     */
    link?: string | null;
}

export interface Tv_dich_vu_tour_Hanh_trinh {
    /**
     * Thời gian bắt đầu
     */
    thoi_gian_bat_dau?: ISODateValue | null;
    /**
     * Thời gian kết thúc
     */
    thoi_gian_ket_thuc?: ISODateValue | null;
    /**
     * Địa điểm bắt đầu
     */
    dia_diem_bat_dau?: IdValue | null;
    /**
     * Địa điểm kết thúc
     */
    dia_diem_ket_thuc?: IdValue | null;
}

export interface Tv_dich_vu_tour_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

export interface Tv_dich_vu_tour_Album_anh {
    anh_id?: IdValue | null;
}

export interface Tv_dich_vu_tour$CustomMethodResource {
    getDiemDenAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getKhoiHanhAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    unApprovedDichVuAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getTourAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tv_dich_vu_tour>({"name":"tv_dich_vu_tour","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_getDiemDen":{},"_raw_http_method_getKhoiHanh":{},"_raw_http_method_unApprovedDichVu":{},"_raw_http_method_getTour":{}},"views":{}}, mushroom);

export interface Tv_dich_vu_tour_cho_duyet {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Mã dịch vụ đã duyệt
     */
    duoc_duyet_id?: IdValue | null;
    /**
     * Tên tour
     */
    ten_tour?: string | null;
    /**
     * Mô tả tour
     */
    mo_ta?: string | null;
    /**
     * Chi tiết tour
     */
    chi_tiet?: string | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Tv_dich_vu_tour_cho_duyet_Thong_tin_chung | null;
    /**
     * Hành trình tour
     */
    hanh_trinh?: Tv_dich_vu_tour_cho_duyet_Hanh_trinh | null;
    duyet?: Tv_dich_vu_tour_cho_duyet_Duyet | null;
    /**
     * id của công ty lữ hành
     */
    cong_ty_lu_hanh_id?: IdValue | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    /**
     * id media
     */
    mediaId?: string | null;
    /**
     * Giá trị ưu đãi
     */
    uu_dai?: string | null;
    /**
     * Ngôn ngữ hiển thị. vi - Việt Nam, en - English
     */
    ngon_ngu?: string | null;
    /**
     * Cho biết đã sẵn sàng chờ duyệt chưa
     */
    ready?: boolean | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
    /**
     * Số lượt xem
     */
    luot_xem?: number | null;
}

export interface Tv_dich_vu_tour_cho_duyet_Thong_tin_chung {
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
    /**
     * Đường dẫn bên Traveloka
     */
    url_traveloka?: string | null;
    /**
     * Đường dẫn bên Ivivu
     */
    url_ivivu?: string | null;
    /**
     * Đường dẫn bên Agoda
     */
    url_agoda?: string | null;
    /**
     * Đường dẫn bên Vntrip
     */
    url_vntrip?: string | null;
    /**
     * Đường dẫn bên chudu24
     */
    url_chudu24?: string | null;
    link_dich_vu?: Array<Tv_dich_vu_tour_cho_duyet_Thong_tin_chung_Link_dich_vu | null | undefined> | null;
    /**
     * Đường dẫn đến các mạng xã hội
     */
    link_mang_xa_hoi?: Array<Tv_dich_vu_tour_cho_duyet_Thong_tin_chung_Link_mang_xa_hoi | null | undefined> | null;
}

export interface Tv_dich_vu_tour_cho_duyet_Thong_tin_chung_Link_dich_vu {
    /**
     * id của dịch vụ
     */
    id?: IdValue | null;
    /**
     * Tên dịch vụ
     */
    link?: string | null;
}

export interface Tv_dich_vu_tour_cho_duyet_Thong_tin_chung_Link_mang_xa_hoi {
    /**
     * Tên mạng xã hội
     */
    name?: string | null;
    /**
     * Link liên kết mạng xã hội
     */
    link?: string | null;
}

export interface Tv_dich_vu_tour_cho_duyet_Hanh_trinh {
    /**
     * Thời gian bắt đầu
     */
    thoi_gian_bat_dau?: ISODateValue | null;
    /**
     * Thời gian kết thúc
     */
    thoi_gian_ket_thuc?: ISODateValue | null;
    /**
     * Địa điểm bắt đầu
     */
    dia_diem_bat_dau?: IdValue | null;
    /**
     * Địa điểm kết thúc
     */
    dia_diem_ket_thuc?: IdValue | null;
}

export interface Tv_dich_vu_tour_cho_duyet_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

export interface Tv_dich_vu_tour_cho_duyet$CustomMethodResource {
    approvedDichVuTourAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tv_dich_vu_tour_cho_duyet>({"name":"tv_dich_vu_tour_cho_duyet","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_approvedDichVuTour":{}},"views":{}}, mushroom);

export interface Tv_tin_tuc {
    id?: IdValue | null;
    /**
     * Tiêu đề tin tức
     */
    tieu_de?: string | null;
    /**
     * Mô tả tin tức
     */
    description?: string | null;
    /**
     * Nội dung tin tức
     */
    content?: string | null;
    /**
     * Id hình ảnh
     */
    image_id?: string | null;
    /**
     * 0: duyệt, 1: chờ đã duyệt, 2: không duyệt
     */
    trang_thai?: number | null;
    /**
     * hien thi
     */
    hien_thi?: boolean | null;
    /**
     * Số lượt xem
     */
    luot_xem?: number | null;
    /**
     * Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng Anh
     */
    ngon_ngu?: string | null;
    /**
     * Nguồn bài viết
     */
    nguon_bai_viet?: Array<IdValue | null | undefined> | null;
    /**
     * Thời gian tạo bản ghi
     */
    thoi_diem_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    lastModificationTime?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    lastModifierUserId?: IdValue | null;
    /**
     * Các thẻ bài viết
     */
    tags?: Array<string | null | undefined> | null;
    /**
     * Loại bài viết. News: Tin tức, SafePlace: Điểm đến
     */
    category?: string | null;
    /**
     * Thành phố của điểm đến
     */
    thanh_pho?: IdValue | null;
    /**
     * Địa chỉ điểm đến
     */
    dia_chi?: string | null;
}

export interface Tv_tin_tuc$CustomMethodResource {
    getNguoiTaoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tv_tin_tuc>({"name":"tv_tin_tuc","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_getNguoiTao":{}},"views":{}}, mushroom);

export interface Tv_phan_hoi {
    id?: IdValue | null;
    /**
     * Mã người phản hồi
     */
    user_id?: IdValue | null;
    /**
     * Thời điểm phản hồi
     */
    thoi_diem_phan_hoi?: ISODateValue | null;
    /**
     * Đối tượng phản hồi
     */
    doi_tuong_phan_hoi?: string | null;
    /**
     * Nội dung phản hồi
     */
    noi_dung?: string | null;
    /**
     * 0: duyệt, 1: chờ duyệt, 2: không duyệt
     */
    trang_thai?: number | null;
}

defineAsyncResource<Tv_phan_hoi>({"name":"tv_phan_hoi","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Khach_du_lich {
    /**
     * Mã người dùng
     */
    id?: IdValue | null;
    /**
     * Mã thẻ
     */
    so_the?: string | null;
    /**
     * Danh sách các thẻ
     */
    danh_sach_the?: Array<string | null | undefined> | null;
    /**
     * Mã people code
     */
    people_code?: string | null;
    /**
     * Tên người dùng
     */
    ho_ten?: Khach_du_lich_Ho_ten | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Ngày tháng năm sinh
     */
    ngay_sinh?: Khach_du_lich_Ngay_sinh | null;
    /**
     * Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu
     */
    giay_to?: Array<Khach_du_lich_Giay_to | null | undefined> | null;
    /**
     * Quốc tịch
     */
    quoc_tich?: Khach_du_lich_Quoc_tich | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Khach_du_lich_Dia_chi | null;
    /**
     * Địa chỉ thường chú
     */
    dia_chi_thuong_chu?: string | null;
    /**
     * Mã ảnh đại diện
     */
    avatar_id?: IdValue | null;
    /**
     * Ảnh CMND/CCCD
     */
    anh_cmnd?: Khach_du_lich_Anh_cmnd | null;
    /**
     * Ảnh chân dung
     */
    avatar_url?: string | null;
}

export interface Khach_du_lich_Ho_ten {
    /**
     * Tên
     */
    ten?: string | null;
    /**
     * Họ
     */
    ho?: string | null;
    /**
     * Họ tên đầy đủ
     */
    ho_ten?: string | null;
    /**
     * Định dạng tên
     */
    dinh_dang?: string | null;
}

export interface Khach_du_lich_Ngay_sinh {
    /**
     * Ngày
     */
    ngay?: number | null;
    /**
     * Tháng
     */
    thang?: number | null;
    /**
     * Năm
     */
    nam?: number | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
}

export interface Khach_du_lich_Giay_to {
    /**
     * Loại giấy tờ
     */
    loai_giay_to?: string | null;
    /**
     * Số giấy tờ
     */
    so_giay_to?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
    /**
     * Ngày cấp
     */
    ngay_cap?: ISODateValue | null;
    /**
     * Ngày hết hạn
     */
    ngay_het_han?: ISODateValue | null;
}

export interface Khach_du_lich_Quoc_tich {
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên quốc tịch
     */
    ten_quoc_tich?: string | null;
}

export interface Khach_du_lich_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Mã phường/xã
     */
    commune_id?: IdValue | null;
    /**
     * Tên phường/xã
     */
    commune_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
}

export interface Khach_du_lich_Anh_cmnd {
    /**
     * Ảnh CMND/CCCD mặt trước
     */
    mat_truoc?: string | null;
    /**
     * Ảnh CMND/CCCD mặt sau
     */
    mat_sau?: string | null;
}

defineAsyncResource<Khach_du_lich>({"name":"khach_du_lich","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{}},"views":{}}, mushroom);

export interface Province {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết tỉnh, thành phố còn tồn tại hay không
     */
    disabled?: boolean | null;
    /**
     * Mã tỉnh, thành phố (theo tổng cục thống kê)
     */
    code?: string | null;
    /**
     * Tên tỉnh, thành phố
     */
    name?: string | null;
    /**
     * Thứ tự sắp xếp của tỉnh, thành phố
     */
    index?: number | null;
    /**
     * Loại (Tỉnh hoặc Thành phố)
     */
    type?: string | null;
    center?: Province_Center | null;
    /**
     * Mã an toàn covid
     */
    atcId?: number | null;
    /**
     * Tên với ngôn ngữ cụ thể
     */
    lang?: Province_Lang | null;
}

export interface Province_Center {
    lng?: number | null;
    lat?: number | null;
}

export interface Province_Lang {
    /**
     * Tên tiếng Việt
     */
    vi?: Province_Lang_Vi | null;
    /**
     * Tên tiếng Anh
     */
    en?: Province_Lang_En | null;
}

export interface Province_Lang_Vi {
    /**
     * Tên tỉnh, thành phố (tiếng Việt)
     */
    name?: string | null;
    /**
     * Loại (tiếng Việt)
     */
    type?: string | null;
    /**
     * Tên đầy đủ tỉnh, thành phố (tiếng Việt)
     */
    fullname?: string | null;
}

export interface Province_Lang_En {
    /**
     * Tên tỉnh, thành phố (tiếng Anh)
     */
    name?: string | null;
    /**
     * Loại (tiếng Anh)
     */
    type?: string | null;
    /**
     * Tên đầy đủ tỉnh, thành phố (tiếng Anh)
     */
    fullname?: string | null;
}

defineAsyncResource<Province>({"name":"province","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface District {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết tỉnh, thành phố còn tồn tại hay không
     */
    disabled?: boolean | null;
    /**
     * Mã quận, huyện, thị xã (theo tổng cục thống kê)
     */
    code?: string | null;
    /**
     * Tên quận, huyện, thị xã
     */
    name?: string | null;
    /**
     * Mã tỉnh
     */
    provinceId?: IdValue | null;
    /**
     * Thứ tự sắp xếp của quận, huyện, thị xã
     */
    index?: number | null;
    /**
     * Loại (Quận, Huyện, Thị xã hoặc Thành phố)
     */
    type?: string | null;
    center?: District_Center | null;
    /**
     * Mã an toàn covid
     */
    atcId?: number | null;
    /**
     * Tên với ngôn ngữ cụ thể
     */
    lang?: District_Lang | null;
}

export interface District_Center {
    lng?: number | null;
    lat?: number | null;
}

export interface District_Lang {
    /**
     * Tên tiếng Việt
     */
    vi?: District_Lang_Vi | null;
    /**
     * Tên tiếng Anh
     */
    en?: District_Lang_En | null;
}

export interface District_Lang_Vi {
    /**
     * Tên quận, huyện, thị xã (tiếng Việt)
     */
    name?: string | null;
    /**
     * Loại (tiếng Việt)
     */
    type?: string | null;
    /**
     * Tên đầy đủ quận, huyện, thị xã (tiếng Việt)
     */
    fullname?: string | null;
}

export interface District_Lang_En {
    /**
     * Tên quận, huyện, thị xã (tiếng Anh)
     */
    name?: string | null;
    /**
     * Loại (tiếng Anh)
     */
    type?: string | null;
    /**
     * Tên đầy đủ quận, huyện, thị xã (tiếng Anh)
     */
    fullname?: string | null;
}

defineAsyncResource<District>({"name":"district","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Commune {
    /**
     * Mã xã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết tỉnh, thành phố còn tồn tại hay không
     */
    disabled?: boolean | null;
    /**
     * Mã huyện
     */
    districtId?: IdValue | null;
    /**
     * Tên phường, xã
     */
    name?: string | null;
    /**
     * Mã phường, xã
     */
    code?: string | null;
    /**
     * Thứ tự sắp xếp
     */
    index?: number | null;
    /**
     * Loại (Xã, Phường, Thị trấn)
     */
    type?: string | null;
    /**
     * Tọa độ xã
     */
    center?: Commune_Center | null;
    /**
     * Mã an toàn covid
     */
    atcId?: number | null;
    /**
     * Tên với ngôn ngữ cụ thể
     */
    lang?: Commune_Lang | null;
}

export interface Commune_Center {
    /**
     * Kinh độ
     */
    lng?: number | null;
    /**
     * vĩ độ
     */
    lat?: number | null;
}

export interface Commune_Lang {
    /**
     * Tên tiếng Việt
     */
    vi?: Commune_Lang_Vi | null;
    /**
     * Tên tiếng Anh
     */
    en?: Commune_Lang_En | null;
}

export interface Commune_Lang_Vi {
    /**
     * Tên phường, xã (tiếng Việt)
     */
    name?: string | null;
    /**
     * Loại (tiếng Việt)
     */
    type?: string | null;
    /**
     * Tên đầy đủ phường, xã (tiếng Việt)
     */
    fullname?: string | null;
}

export interface Commune_Lang_En {
    /**
     * Tên phường, xã (tiếng Anh)
     */
    name?: string | null;
    /**
     * Loại (tiếng Anh)
     */
    type?: string | null;
    /**
     * Tên đầy phường, xã (tiếng Anh)
     */
    fullname?: string | null;
}

defineAsyncResource<Commune>({"name":"commune","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Cong_ty_lu_hanh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Cho biết Công ty có bị disable hay không
     */
    isDisabled?: boolean | null;
    /**
     * Tên sở trường
     */
    ten?: Cong_ty_lu_hanh_Ten | null;
    /**
     * Hotline
     */
    hotline?: string | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Số điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Slogan
     */
    slogan?: string | null;
    /**
     * Mã ảnh đại diện
     */
    avatar_id?: IdValue | null;
    /**
     * Địa chỉ
     */
    dia_chi?: Cong_ty_lu_hanh_Dia_chi | null;
    /**
     * Giấy phép kinh doanh lữ hành
     */
    giay_phep_kinh_doanh?: Cong_ty_lu_hanh_Giay_phep_kinh_doanh | null;
    /**
     * Danh sách mã người quản lý công ty lữ hành
     */
    nguoi_quan_ly_ids?: Array<IdValue | null | undefined> | null;
    /**
     * [Dùng cho tool import dữ liệu] Version của dữ liệu
     */
    __version?: Cong_ty_lu_hanh___version | null;
}

export interface Cong_ty_lu_hanh_Ten {
    /**
     * Tên tiếng Việt
     */
    vi?: string | null;
    /**
     * Tên tiếng Anh
     */
    en?: string | null;
}

export interface Cong_ty_lu_hanh_Dia_chi {
    /**
     * Mã tỉnh/TP
     */
    province_id?: IdValue | null;
    /**
     * Tên tỉnh/TP
     */
    province_name?: string | null;
    /**
     * Mã quận/huyện
     */
    district_id?: IdValue | null;
    /**
     * Tên quận/huyện
     */
    district_name?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
}

export interface Cong_ty_lu_hanh_Giay_phep_kinh_doanh {
    /**
     * Số giấy phép
     */
    so_giay_phep?: string | null;
    /**
     * Nơi cấp
     */
    noi_cap?: string | null;
}

export interface Cong_ty_lu_hanh___version {
    /**
     * Mã băm
     */
    hashCode?: number | null;
    /**
     * Mã dữ liệu tại nguồn
     */
    srcId?: string | null;
}

export interface Cong_ty_lu_hanh$CustomMethodResource {
    getAccountAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Cong_ty_lu_hanh>({"name":"cong_ty_lu_hanh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_getAccount":{}},"views":{}}, mushroom);

export interface Tv_cong_ty_lu_hanh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Các thông tin cho hướng dẫn viên
     */
    huong_dan_vien?: Tv_cong_ty_lu_hanh_Huong_dan_vien | null;
}

export interface Tv_cong_ty_lu_hanh_Huong_dan_vien {
    /**
     * Thông tin ưu đãi
     */
    uu_dai?: Tv_cong_ty_lu_hanh_Huong_dan_vien_Uu_dai | null;
}

export interface Tv_cong_ty_lu_hanh_Huong_dan_vien_Uu_dai {
    /**
     * Loại hình ưu đãi
     */
    loai_hinh_uu_dai?: string | null;
    /**
     * Giá trị ưu đãi
     */
    gia_tri_uu_dai?: number | null;
}

export interface Tv_cong_ty_lu_hanh$CustomMethodResource {
    update_hdv_uu_daiAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tv_cong_ty_lu_hanh>({"name":"tv_cong_ty_lu_hanh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"_raw_http_method_update_hdv_uu_dai":{}},"views":{}}, mushroom);

export interface Tv_info_diem_den {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thông tin duyệt
     */
    duyet?: Tv_info_diem_den_Duyet | null;
    /**
     * Thông tin điểm đến
     */
    thong_tin_chung?: Tv_info_diem_den_Thong_tin_chung | null;
    /**
     * Dữ liệu khai báo khi đăng ký điểm đến an toàn
     */
    du_lieu_khai_bao?: Tv_info_diem_den_Du_lieu_khai_bao | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời điểm cập nhật cuối
     */
    thoi_diem_cap_nhat_cuoi?: ISODateValue | null;
}

export interface Tv_info_diem_den_Duyet {
    /**
     * Cho biết điểm đến đã được duyệt hay chưa
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm điểm đến đã được duyệt
     */
    thoi_diem_duoc_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

export interface Tv_info_diem_den_Thong_tin_chung {
    /**
     * Tên điểm đến an toàn
     */
    ten?: string | null;
    /**
     * Mã ảnh đại diện user
     */
    anh?: string | null;
    /**
     * Thông tin địa chỉ
     */
    dia_chi?: Tv_info_diem_den_Thong_tin_chung_Dia_chi | null;
    /**
     * Thông tin người đại diện
     */
    nguoi_dai_dien?: Tv_info_diem_den_Thong_tin_chung_Nguoi_dai_dien | null;
}

export interface Tv_info_diem_den_Thong_tin_chung_Dia_chi {
    /**
     * Quốc gia
     */
    quoc_gia?: string | null;
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên tỉnh
     */
    tinh?: string | null;
    /**
     * Mã tỉnh
     */
    tinh_id?: IdValue | null;
    /**
     * Tên huyện
     */
    huyen?: string | null;
    /**
     * Mã huyện
     */
    huyen_id?: IdValue | null;
    /**
     * Tên xa
     */
    xa?: string | null;
    /**
     * Mã xã
     */
    xa_id?: IdValue | null;
    /**
     * Địa chỉ giao dịch
     */
    dia_chi?: string | null;
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
}

export interface Tv_info_diem_den_Thong_tin_chung_Nguoi_dai_dien {
    /**
     * Họ và tên
     */
    ho_ten?: string | null;
    /**
     * Chức vụ
     */
    chuc_vu?: string | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
    /**
     * Số CMT/ Căn cước/ Hộ chiếu
     */
    so_giay_to?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
}

export interface Tv_info_diem_den_Du_lieu_khai_bao {
    /**
     * account của điểm đến
     */
    user_account?: string | null;
}

defineAsyncResource<Tv_info_diem_den>({"name":"tv_info_diem_den","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Tv_info_ve_dien_tu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Thông tin duyệt
     */
    duyet?: Tv_info_ve_dien_tu_Duyet | null;
    /**
     * Tỉnh thành
     */
    tinh_thanh?: string | null;
    /**
     * Thông tin cơ sở
     */
    thong_tin_chung?: Tv_info_ve_dien_tu_Thong_tin_chung | null;
    /**
     * Dữ liệu khai báo khi đăng ký điểm đến an toàn
     */
    du_lieu_khai_bao?: Tv_info_ve_dien_tu_Du_lieu_khai_bao | null;
    /**
     * Mã người tạo
     */
    nguoi_tao_id?: IdValue | null;
    /**
     * Thời điểm tạo
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời điểm cập nhật cuối
     */
    thoi_diem_cap_nhat_cuoi?: ISODateValue | null;
}

export interface Tv_info_ve_dien_tu_Duyet {
    /**
     * Cho biết điểm đến đã được duyệt hay chưa
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm điểm đến đã được duyệt
     */
    thoi_diem_duoc_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

export interface Tv_info_ve_dien_tu_Thong_tin_chung {
    /**
     * Tên cơ sở
     */
    ten?: string | null;
    /**
     * Mã ảnh đại diện user
     */
    anh?: string | null;
    /**
     * Thông tin địa chỉ
     */
    dia_chi?: Tv_info_ve_dien_tu_Thong_tin_chung_Dia_chi | null;
    /**
     * Thông tin người đại diện
     */
    nguoi_dai_dien?: Tv_info_ve_dien_tu_Thong_tin_chung_Nguoi_dai_dien | null;
}

export interface Tv_info_ve_dien_tu_Thong_tin_chung_Dia_chi {
    /**
     * Quốc gia
     */
    quoc_gia?: string | null;
    /**
     * Mã quốc tịch
     */
    quoc_tich_id?: IdValue | null;
    /**
     * Tên tỉnh
     */
    tinh?: string | null;
    /**
     * Mã tỉnh
     */
    tinh_id?: IdValue | null;
    /**
     * Tên huyện
     */
    huyen?: string | null;
    /**
     * Mã huyện
     */
    huyen_id?: IdValue | null;
    /**
     * Tên xa
     */
    xa?: string | null;
    /**
     * Mã xã
     */
    xa_id?: IdValue | null;
    /**
     * Địa chỉ giao dịch
     */
    dia_chi?: string | null;
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
}

export interface Tv_info_ve_dien_tu_Thong_tin_chung_Nguoi_dai_dien {
    /**
     * Họ và tên
     */
    ho_ten?: string | null;
    /**
     * Chức vụ
     */
    chuc_vu?: string | null;
    /**
     * Ngày sinh
     */
    ngay_sinh?: ISODateValue | null;
    /**
     * Số CMT/ Căn cước/ Hộ chiếu
     */
    so_giay_to?: string | null;
    /**
     * Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
     */
    gioi_tinh?: number | null;
    /**
     * Địa chỉ
     */
    dia_chi?: string | null;
    /**
     * Điện thoại
     */
    dien_thoai?: string | null;
    /**
     * Email
     */
    email?: string | null;
}

export interface Tv_info_ve_dien_tu_Du_lieu_khai_bao {
    /**
     * account của điểm đến
     */
    user_account?: string | null;
}

defineAsyncResource<Tv_info_ve_dien_tu>({"name":"tv_info_ve_dien_tu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Tv_nen_tang_dich_vu {
    id?: IdValue | null;
    /**
     * Tên nền tảng
     */
    ten?: string | null;
    /**
     * hien thi
     */
    hien_thi?: boolean | null;
    /**
     * Id hình ảnh
     */
    image_id?: IdValue | null;
    /**
     * Loại dịch vụ. Tour, Lưu trú, Ẩm thực, Điểm đến, Giải trí, Vận tải khách
     */
    dich_vu?: string | null;
    /**
     * Thời gian tạo bản ghi
     */
    thoi_diem_tao?: ISODateValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    lastModificationTime?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    lastModifierUserId?: IdValue | null;
}

defineAsyncResource<Tv_nen_tang_dich_vu>({"name":"tv_nen_tang_dich_vu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Notification {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã loại thông báo. Chi tiết xem tại: https://docs.google.com/document/d/1y_X4gFrT-Ws2cdziM00t2cE_6HJfG1JmD_uhgeEZhgs/edit
     */
    type?: string | null;
    /**
     * Tiêu đề thông báo
     */
    title?: string | null;
    /**
     * Mô tả ngắn của thông báo, định dạng plain text
     */
    intro?: string | null;
    /**
     * Mã của nguồn phát sinh ra thông báo gửi. Ví dụ: user_id...
     */
    from?: IdValue | null;
    /**
     * Mã người nhận
     */
    to?: IdValue | null;
    /**
     * Cho biết người dùng đã đọc hay chưa
     */
    isRead?: boolean | null;
    /**
     * Thời điểm tạo
     */
    createdTime?: ISODateValue | null;
    /**
     * Thời hết hạn
     */
    expiredTime?: ISODateValue | null;
    /**
     * Thông tin đích của thông báo
     */
    target?: Notification_Target | null;
}

export interface Notification_Target {
    /**
     * Dữ liệu text của đích, ví dụ: url...
     */
    value?: string | null;
    /**
     * Mã tham chiếu của đích trong nội bộ, ví dụ: tour_id, phieu_dieu_tour_id...
     */
    targetId?: IdValue | null;
}

defineAsyncResource<Notification>({"name":"notification","actions":{"findMany":{"includeTotal":true},"findById":{},"createOne":{},"updatePartially":{},"deleteOne":{},"deleteMany":{}},"views":{}}, mushroom);

export interface Tv_don_vi_cung_cap {
    /**
     * Mã điểm đến an toàn
     */
    id?: IdValue | null;
    /**
     * Loại dịch vụ của đơn vị cung cấp
     */
    loai?: string | null;
    /**
     * Dữ liệu khai báo khi đăng ký điểm đến an toàn
     */
    du_lieu_khai_bao?: Tv_don_vi_cung_cap_Du_lieu_khai_bao | null;
    duyet?: Tv_don_vi_cung_cap_Duyet | null;
    /**
     * Lưu trú
     */
    luu_tru?: Tv_don_vi_cung_cap_Luu_tru | null;
    /**
     * Ẩm thực
     */
    am_thuc?: Tv_don_vi_cung_cap_Am_thuc | null;
    /**
     * Vé điện tử
     */
    ve_dien_tu?: Tv_don_vi_cung_cap_Ve_dien_tu | null;
    /**
     * Điểm đến
     */
    diem_den?: Tv_don_vi_cung_cap_Diem_den | null;
    /**
     * Giải trí
     */
    giai_tri?: Tv_don_vi_cung_cap_Giai_tri | null;
    /**
     * Vận tải khách
     */
    van_tai_khach?: Tv_don_vi_cung_cap_Van_tai_khach | null;
    /**
     * Lữ hành nội địa
     */
    lu_hanh_noi_dia?: Tv_don_vi_cung_cap_Lu_hanh_noi_dia | null;
    /**
     * Lữ hành quốc tế
     */
    lu_hanh_quoc_te?: Tv_don_vi_cung_cap_Lu_hanh_quoc_te | null;
    /**
     * Khu du lịch
     */
    khu_du_lich?: Tv_don_vi_cung_cap_Khu_du_lich | null;
    /**
     * Điểm du lịch
     */
    diem_du_lich?: Tv_don_vi_cung_cap_Diem_du_lich | null;
    /**
     * Điểm mua sắm
     */
    diem_mua_sam?: Tv_don_vi_cung_cap_Diem_mua_sam | null;
    /**
     * Cơ quan quản lý nhà nước
     */
    co_quan_nha_nuoc?: Tv_don_vi_cung_cap_Co_quan_nha_nuoc | null;
    /**
     * Dịch vụ liên quan khác phục vụ khách du lịch
     */
    dich_vu_khac?: Tv_don_vi_cung_cap_Dich_vu_khac | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
}

export interface Tv_don_vi_cung_cap_Du_lieu_khai_bao {
    /**
     * account của điểm đến
     */
    user_account?: string | null;
    /**
     * user_ten của điểm đến
     */
    user_ten?: string | null;
}

export interface Tv_don_vi_cung_cap_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
}

export interface Tv_don_vi_cung_cap_Luu_tru {
    /**
     * Số sao
     */
    so_sao?: number | null;
}

export interface Tv_don_vi_cung_cap_Am_thuc {
    dich_vu?: Array<IdValue | null | undefined> | null;
}

export interface Tv_don_vi_cung_cap_Ve_dien_tu {
    /**
     * Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật, transport_ticket: vé giao thông
     */
    loai?: string | null;
}

export interface Tv_don_vi_cung_cap_Diem_den {
}

export interface Tv_don_vi_cung_cap_Giai_tri {
}

export interface Tv_don_vi_cung_cap_Van_tai_khach {
}

export interface Tv_don_vi_cung_cap_Lu_hanh_noi_dia {
}

export interface Tv_don_vi_cung_cap_Lu_hanh_quoc_te {
}

export interface Tv_don_vi_cung_cap_Khu_du_lich {
}

export interface Tv_don_vi_cung_cap_Diem_du_lich {
}

export interface Tv_don_vi_cung_cap_Diem_mua_sam {
}

export interface Tv_don_vi_cung_cap_Co_quan_nha_nuoc {
}

export interface Tv_don_vi_cung_cap_Dich_vu_khac {
}

export interface Tv_don_vi_cung_cap$CustomMethodResource {
    getWebsiteAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Tv_don_vi_cung_cap$ViewsResource_getProvicesView_Parameters {
    /**
     * Loại điểm đến
     */
    loai: string;
};
export interface Tv_don_vi_cung_cap$ViewsResource_searchDiemDenView_Parameters {
    /**
     * Tên tỉnh
     */
    tinh?: string | null;
    /**
     * Skip
     */
    skip?: number | null;
    /**
     * Limit
     */
    limit?: number | null;
};
export interface Tv_don_vi_cung_cap$ViewsResource_totalSearchDiemDenView_Parameters {
    /**
     * Mã tỉnh
     */
    tinh_ids: IdValue[];
};
export interface Tv_don_vi_cung_cap$ViewsResource_searchGiaiTriView_Parameters {
    /**
     * Mã tỉnh
     */
    tinh_id?: string[] | null;
};
export interface Tv_don_vi_cung_cap$ViewsResource {
    views: {
        getProvicesAsync: MushroomViewFunction<any, Tv_don_vi_cung_cap$ViewsResource_getProvicesView_Parameters>;
        searchDiemDenAsync: MushroomViewFunction<any, Tv_don_vi_cung_cap$ViewsResource_searchDiemDenView_Parameters>;
        totalSearchDiemDenAsync: MushroomViewFunction<any, Tv_don_vi_cung_cap$ViewsResource_totalSearchDiemDenView_Parameters>;
        searchGiaiTriAsync: MushroomViewFunction<any, Tv_don_vi_cung_cap$ViewsResource_searchGiaiTriView_Parameters>;
    }
}
defineAsyncResource<Tv_don_vi_cung_cap>({"name":"tv_don_vi_cung_cap","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_getWebsite":{}},"views":{"getProvices":{"clientCache":true},"searchDiemDen":{"clientCache":true},"totalSearchDiemDen":{"clientCache":true},"searchGiaiTri":{"clientCache":true}}}, mushroom);

export interface Tv_don_vi_cung_cap_cho_duyet {
    /**
     * Mã điểm đến an toàn
     */
    id?: IdValue | null;
    /**
     * Loại dịch vụ của đơn vị cung cấp
     */
    loai?: string | null;
    /**
     * Dữ liệu khai báo khi đăng ký điểm đến an toàn
     */
    du_lieu_khai_bao?: Tv_don_vi_cung_cap_cho_duyet_Du_lieu_khai_bao | null;
    duyet?: Tv_don_vi_cung_cap_cho_duyet_Duyet | null;
    /**
     * Lưu trú
     */
    luu_tru?: Tv_don_vi_cung_cap_cho_duyet_Luu_tru | null;
    /**
     * Ẩm thực
     */
    am_thuc?: Tv_don_vi_cung_cap_cho_duyet_Am_thuc | null;
    /**
     * Vé điện tử
     */
    ve_dien_tu?: Tv_don_vi_cung_cap_cho_duyet_Ve_dien_tu | null;
    /**
     * Điểm đến
     */
    diem_den?: Tv_don_vi_cung_cap_cho_duyet_Diem_den | null;
    /**
     * Giải trí
     */
    giai_tri?: Tv_don_vi_cung_cap_cho_duyet_Giai_tri | null;
    /**
     * Vận tải khách
     */
    van_tai_khach?: Tv_don_vi_cung_cap_cho_duyet_Van_tai_khach | null;
    /**
     * Lữ hành nội địa
     */
    lu_hanh_noi_dia?: Tv_don_vi_cung_cap_cho_duyet_Lu_hanh_noi_dia | null;
    /**
     * Lữ hành quốc tế
     */
    lu_hanh_quoc_te?: Tv_don_vi_cung_cap_cho_duyet_Lu_hanh_quoc_te | null;
    /**
     * Khu du lịch
     */
    khu_du_lich?: Tv_don_vi_cung_cap_cho_duyet_Khu_du_lich | null;
    /**
     * Điểm du lịch
     */
    diem_du_lich?: Tv_don_vi_cung_cap_cho_duyet_Diem_du_lich | null;
    /**
     * Điểm mua sắm
     */
    diem_mua_sam?: Tv_don_vi_cung_cap_cho_duyet_Diem_mua_sam | null;
    /**
     * Cơ quan quản lý nhà nước
     */
    co_quan_nha_nuoc?: Tv_don_vi_cung_cap_cho_duyet_Co_quan_nha_nuoc | null;
    /**
     * Dịch vụ liên quan khác phục vụ khách du lịch
     */
    dich_vu_khac?: Tv_don_vi_cung_cap_cho_duyet_Dich_vu_khac | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
}

export interface Tv_don_vi_cung_cap_cho_duyet_Du_lieu_khai_bao {
    /**
     * account của điểm đến
     */
    user_account?: string | null;
    /**
     * user_ten của điểm đến
     */
    user_ten?: string | null;
}

export interface Tv_don_vi_cung_cap_cho_duyet_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
}

export interface Tv_don_vi_cung_cap_cho_duyet_Luu_tru {
    /**
     * Số sao
     */
    so_sao?: number | null;
}

export interface Tv_don_vi_cung_cap_cho_duyet_Am_thuc {
    dich_vu?: Array<IdValue | null | undefined> | null;
}

export interface Tv_don_vi_cung_cap_cho_duyet_Ve_dien_tu {
    /**
     * Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật, transport_ticket: Vé giao thông
     */
    loai?: string | null;
}

export interface Tv_don_vi_cung_cap_cho_duyet_Diem_den {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Giai_tri {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Van_tai_khach {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Lu_hanh_noi_dia {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Lu_hanh_quoc_te {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Khu_du_lich {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Diem_du_lich {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Diem_mua_sam {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Co_quan_nha_nuoc {
}

export interface Tv_don_vi_cung_cap_cho_duyet_Dich_vu_khac {
}

export interface Tv_don_vi_cung_cap_cho_duyet$CustomMethodResource {
    getThanhPhoAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getDichVuAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getWebsiteAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    approvedDonViAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    registerTrangVangAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    updateEmailAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tv_don_vi_cung_cap_cho_duyet>({"name":"tv_don_vi_cung_cap_cho_duyet","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_getThanhPho":{},"_raw_http_method_getDichVu":{},"_raw_http_method_getWebsite":{},"_raw_http_method_approvedDonVi":{},"_raw_http_method_registerTrangVang":{},"_raw_http_method_updateEmail":{}},"views":{}}, mushroom);

export interface Tv_dich_vu {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Điểm đến an toàn id
     */
    diem_den_an_toan_id?: IdValue | null;
    /**
     * Loại dịch vụ du lịch
     */
    loai?: string | null;
    /**
     * Cho phép dịch vụ ẩn/ hiện
     */
    visible?: boolean | null;
    duyet?: Tv_dich_vu_Duyet | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Tv_dich_vu_Thong_tin_chung | null;
    /**
     * Lưu trú
     */
    luu_tru?: Tv_dich_vu_Luu_tru | null;
    /**
     * Ẩm thực
     */
    am_thuc?: Tv_dich_vu_Am_thuc | null;
    /**
     * Vé điện tử
     */
    ve_dien_tu?: Tv_dich_vu_Ve_dien_tu | null;
    /**
     * Điểm đến
     */
    diem_den?: Tv_dich_vu_Diem_den | null;
    /**
     * Giải trí
     */
    giai_tri?: Tv_dich_vu_Giai_tri | null;
    /**
     * Vận tải khách
     */
    van_tai_khach?: Tv_dich_vu_Van_tai_khach | null;
    /**
     * Lữ hành nội địa
     */
    lu_hanh_noi_dia?: Tv_dich_vu_Lu_hanh_noi_dia | null;
    /**
     * Lữ hành quốc tế
     */
    lu_hanh_quoc_te?: Tv_dich_vu_Lu_hanh_quoc_te | null;
    /**
     * Khu du lịch
     */
    khu_du_lich?: Tv_dich_vu_Khu_du_lich | null;
    /**
     * Điểm du lịch
     */
    diem_du_lich?: Tv_dich_vu_Diem_du_lich | null;
    /**
     * Điểm mua sắm
     */
    diem_mua_sam?: Tv_dich_vu_Diem_mua_sam | null;
    /**
     * Cơ quan quản lý nhà nước
     */
    co_quan_nha_nuoc?: Tv_dich_vu_Co_quan_nha_nuoc | null;
    /**
     * Dịch vụ liên quan khác phục vụ khách du lịch
     */
    dich_vu_khac?: Tv_dich_vu_Dich_vu_khac | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    link_dich_vu?: Array<Tv_dich_vu_Link_dich_vu | null | undefined> | null;
    /**
     * Giá trị ưu đãi
     */
    uu_dai?: string | null;
    /**
     * Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng anh
     */
    ngon_ngu?: string | null;
    /**
     * Số lượt xem
     */
    luot_xem?: number | null;
    /**
     * Đường dẫn đến các mạng xã hội
     */
    link_mang_xa_hoi?: Array<Tv_dich_vu_Link_mang_xa_hoi | null | undefined> | null;
}

export interface Tv_dich_vu_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
}

export interface Tv_dich_vu_Thong_tin_chung {
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
    /**
     * Danh sách ảnh trong album
     */
    album_anh?: Array<Tv_dich_vu_Thong_tin_chung_Album_anh | null | undefined> | null;
}

export interface Tv_dich_vu_Thong_tin_chung_Album_anh {
    anh_id?: IdValue | null;
}

export interface Tv_dich_vu_Luu_tru {
    /**
     * Tên lưu trú
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Số giường người lớn
     */
    so_giuong_nguoi_lon?: number | null;
    /**
     * Số giường trẻ em
     */
    so_giuong_tre_em?: number | null;
    /**
     * Số ngày đặt phòng
     */
    so_ngay_dat_phong?: number | null;
    /**
     * Mô tả lưu trú
     */
    mo_ta?: string | null;
    /**
     * Chi tiết lưu trú
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Am_thuc {
    /**
     * Tên ẩm thực
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Mô tả ẩm thực
     */
    mo_ta?: string | null;
    /**
     * Chi tiết ẩm thực
     */
    chi_tiet?: string | null;
    /**
     * Giờ mở cửa
     */
    gio_mo_cua?: string | null;
    /**
     * Giá tiền
     */
    gia_tien?: string | null;
}

export interface Tv_dich_vu_Ve_dien_tu {
    /**
     * Tên vé điệnt tử
     */
    ten?: string | null;
    /**
     * Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật, transport_ticket: vé giao thông
     */
    loai?: string | null;
    /**
     * Đường dẫn vé điện tử
     */
    url?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
}

export interface Tv_dich_vu_Diem_den {
    /**
     * Tên điểm đến
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm đến
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm đến
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Giai_tri {
    /**
     * Tên địa điểm giải trí
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu về khu giải trí
     */
    mo_ta?: string | null;
    /**
     * Chi tiết về khi giải trí
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Van_tai_khach {
    /**
     * Tên đơn vị vận tải khách
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu đơn vị vận tải khách
     */
    mo_ta?: string | null;
    /**
     * Chi tiết đơn vị vận tải khách
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Lu_hanh_noi_dia {
    /**
     * Tên đơn vị lữ hành nội địa
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu đơn vị lữ hành nội địa
     */
    mo_ta?: string | null;
    /**
     * Chi tiết đơn vị lữ hành nội địa
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Lu_hanh_quoc_te {
    /**
     * Tên đơn vị lữ hành quốc tế
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu đơn vị lữ hành quốc tế
     */
    mo_ta?: string | null;
    /**
     * Chi tiết đơn vị lữ hành quốc tế
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Khu_du_lich {
    /**
     * Tên khu du lịch
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu khu du lịch
     */
    mo_ta?: string | null;
    /**
     * Chi tiết khu du lịch
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Diem_du_lich {
    /**
     * Tên điểm du lịch
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm du lịch
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm du lịch
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Diem_mua_sam {
    /**
     * Tên điểm mua sắm
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm mua sắm
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm mua sắm
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Co_quan_nha_nuoc {
    /**
     * Tên cơ quan quản lý nhà nước
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu cơ quan quản lý nhà nước
     */
    mo_ta?: string | null;
    /**
     * Chi tiết cơ quan quản lý nhà nước
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Dich_vu_khac {
    /**
     * Tên dịch vụ khác
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu dịch vụ khác
     */
    mo_ta?: string | null;
    /**
     * Chi tiết dịch vụ khác
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_Link_dich_vu {
    /**
     * id của dịch vụ
     */
    id?: IdValue | null;
    /**
     * Tên dịch vụ
     */
    link?: string | null;
}

export interface Tv_dich_vu_Link_mang_xa_hoi {
    /**
     * Tên mạng xã hội
     */
    name?: string | null;
    /**
     * Link liên kết mạng xã hội
     */
    link?: string | null;
}

export interface Tv_dich_vu$CustomMethodResource {
    getLuuTruAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getDiemDenAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getAmThucAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getVeDienTuAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    getGiaiTriAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
    unApprovedDichVuAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tv_dich_vu>({"name":"tv_dich_vu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_getLuuTru":{},"_raw_http_method_getDiemDen":{},"_raw_http_method_getAmThuc":{},"_raw_http_method_getVeDienTu":{},"_raw_http_method_getGiaiTri":{},"_raw_http_method_unApprovedDichVu":{}},"views":{}}, mushroom);

export interface Tv_dich_vu_deleted {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Điểm đến an toàn id
     */
    diem_den_an_toan_id?: IdValue | null;
    /**
     * Loại dịch vụ du lịch
     */
    loai?: string | null;
    /**
     * Cho phép dịch vụ ẩn/ hiện
     */
    visible?: boolean | null;
    duyet?: Tv_dich_vu_deleted_Duyet | null;
    /**
     * Lưu trú
     */
    luu_tru?: Tv_dich_vu_deleted_Luu_tru | null;
    /**
     * Ẩm thực
     */
    am_thuc?: Tv_dich_vu_deleted_Am_thuc | null;
    /**
     * Vé điện tử
     */
    ve_dien_tu?: Tv_dich_vu_deleted_Ve_dien_tu | null;
    /**
     * Điểm đến
     */
    diem_den?: Tv_dich_vu_deleted_Diem_den | null;
    /**
     * Giải trí
     */
    giai_tri?: Tv_dich_vu_deleted_Giai_tri | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    link_dich_vu?: Array<Tv_dich_vu_deleted_Link_dich_vu | null | undefined> | null;
    /**
     * Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng anh
     */
    ngon_ngu?: string | null;
}

export interface Tv_dich_vu_deleted_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
}

export interface Tv_dich_vu_deleted_Luu_tru {
    /**
     * Tên lưu trú
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Số giường người lớn
     */
    so_giuong_nguoi_lon?: number | null;
    /**
     * Số giường trẻ em
     */
    so_giuong_tre_em?: number | null;
    /**
     * Số ngày đặt phòng
     */
    so_ngay_dat_phong?: number | null;
    /**
     * Mô tả lưu trú
     */
    mo_ta?: string | null;
    /**
     * Chi tiết lưu trú
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_deleted_Am_thuc {
    /**
     * Tên ẩm thực
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Mô tả ẩm thực
     */
    mo_ta?: string | null;
    /**
     * Chi tiết ẩm thực
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_deleted_Ve_dien_tu {
    /**
     * Tên vé điệnt tử
     */
    ten?: string | null;
    /**
     * Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật, transport_ticket: vé giao thông
     */
    loai?: string | null;
    /**
     * Đường dẫn vé điện tử
     */
    url?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
}

export interface Tv_dich_vu_deleted_Diem_den {
    /**
     * Tên điểm đến
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm đến
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm đến
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_deleted_Giai_tri {
    /**
     * Tên địa điểm giải trí
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu về khu giải trí
     */
    mo_ta?: string | null;
    /**
     * Chi tiết về khi giải trí
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_deleted_Link_dich_vu {
    /**
     * id của dịch vụ
     */
    id?: IdValue | null;
    /**
     * Tên dịch vụ
     */
    link?: string | null;
}

defineAsyncResource<Tv_dich_vu_deleted>({"name":"tv_dich_vu_deleted","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Tv_dich_vu_cho_duyet {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Điểm đến an toàn id
     */
    diem_den_an_toan_id?: IdValue | null;
    /**
     * Mã dịch vụ đã duyệt
     */
    duoc_duyet_id?: IdValue | null;
    /**
     * Loại dịch vụ du lịch
     */
    loai?: string | null;
    duyet?: Tv_dich_vu_cho_duyet_Duyet | null;
    /**
     * Lý do từ chối
     */
    ly_do_tu_choi?: string | null;
    /**
     * Thông tin chung
     */
    thong_tin_chung?: Tv_dich_vu_cho_duyet_Thong_tin_chung | null;
    /**
     * Lưu trú
     */
    luu_tru?: Tv_dich_vu_cho_duyet_Luu_tru | null;
    /**
     * Ẩm thực
     */
    am_thuc?: Tv_dich_vu_cho_duyet_Am_thuc | null;
    /**
     * Vé điện tử
     */
    ve_dien_tu?: Tv_dich_vu_cho_duyet_Ve_dien_tu | null;
    /**
     * Điểm đến
     */
    diem_den?: Tv_dich_vu_cho_duyet_Diem_den | null;
    /**
     * Giải trí
     */
    giai_tri?: Tv_dich_vu_cho_duyet_Giai_tri | null;
    /**
     * Vận tải khách
     */
    van_tai_khach?: Tv_dich_vu_cho_duyet_Van_tai_khach | null;
    /**
     * Lữ hành nội địa
     */
    lu_hanh_noi_dia?: Tv_dich_vu_cho_duyet_Lu_hanh_noi_dia | null;
    /**
     * Lữ hành quốc tế
     */
    lu_hanh_quoc_te?: Tv_dich_vu_cho_duyet_Lu_hanh_quoc_te | null;
    /**
     * Khu du lịch
     */
    khu_du_lich?: Tv_dich_vu_cho_duyet_Khu_du_lich | null;
    /**
     * Điểm du lịch
     */
    diem_du_lich?: Tv_dich_vu_cho_duyet_Diem_du_lich | null;
    /**
     * Điểm mua sắm
     */
    diem_mua_sam?: Tv_dich_vu_cho_duyet_Diem_mua_sam | null;
    /**
     * Cơ quan quản lý nhà nước
     */
    co_quan_nha_nuoc?: Tv_dich_vu_cho_duyet_Co_quan_nha_nuoc | null;
    /**
     * Dịch vụ liên quan khác phục vụ khách du lịch
     */
    dich_vu_khac?: Tv_dich_vu_cho_duyet_Dich_vu_khac | null;
    thoi_gian_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    link_dich_vu?: Array<Tv_dich_vu_cho_duyet_Link_dich_vu | null | undefined> | null;
    /**
     * Giá trị ưu đãi
     */
    uu_dai?: string | null;
    /**
     * Cho biết đã sẵn sàng chờ duyệt chưa
     */
    ready?: boolean | null;
    /**
     * Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng anh
     */
    ngon_ngu?: string | null;
    /**
     * Số lượt xem
     */
    luot_xem?: number | null;
    /**
     * Đường dẫn đến các mạng xã hội
     */
    link_mang_xa_hoi?: Array<Tv_dich_vu_cho_duyet_Link_mang_xa_hoi | null | undefined> | null;
}

export interface Tv_dich_vu_cho_duyet_Duyet {
    /**
     * Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
     */
    duoc_duyet?: boolean | null;
    /**
     * Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
     */
    thoi_diem_duyet?: ISODateValue | null;
    /**
     * Mã người duyệt
     */
    nguoi_duyet_id?: IdValue | null;
}

export interface Tv_dich_vu_cho_duyet_Thong_tin_chung {
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
    /**
     * Danh sách ảnh trong album
     */
    album_anh?: Array<Tv_dich_vu_cho_duyet_Thong_tin_chung_Album_anh | null | undefined> | null;
}

export interface Tv_dich_vu_cho_duyet_Thong_tin_chung_Album_anh {
    anh_id?: IdValue | null;
}

export interface Tv_dich_vu_cho_duyet_Luu_tru {
    /**
     * Tên lưu trú
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Số giường người lớn
     */
    so_giuong_nguoi_lon?: number | null;
    /**
     * Số giường trẻ em
     */
    so_giuong_tre_em?: number | null;
    /**
     * Số ngày đặt phòng
     */
    so_ngay_dat_phong?: number | null;
    /**
     * Mô tả lưu trú
     */
    mo_ta?: string | null;
    /**
     * Chi tiết lưu trú
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Am_thuc {
    /**
     * Tên ẩm thực
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Mô tả ẩm thực
     */
    mo_ta?: string | null;
    /**
     * Chi tiết ẩm thực
     */
    chi_tiet?: string | null;
    /**
     * Giờ mở cửa
     */
    gio_mo_cua?: string | null;
    /**
     * Giá tiền
     */
    gia_tien?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Ve_dien_tu {
    /**
     * Tên vé điệnt tử
     */
    ten?: string | null;
    /**
     * Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật, transport_ticket: vé giao thông
     */
    loai?: string | null;
    /**
     * Đường dẫn vé điện tử
     */
    url?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
}

export interface Tv_dich_vu_cho_duyet_Diem_den {
    /**
     * Tên điểm đến
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm đến
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm đến
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Giai_tri {
    /**
     * Tên địa điểm giải trí
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu về khu giải trí
     */
    mo_ta?: string | null;
    /**
     * Chi tiết về khi giải trí
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Van_tai_khach {
    /**
     * Tên đơn vị vận tải khách
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu đơn vị vận tải khách
     */
    mo_ta?: string | null;
    /**
     * Chi tiết đơn vị vận tải khách
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Lu_hanh_noi_dia {
    /**
     * Tên đơn vị lữ hành nội địa
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu đơn vị lữ hành nội địa
     */
    mo_ta?: string | null;
    /**
     * Chi tiết đơn vị lữ hành nội địa
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Lu_hanh_quoc_te {
    /**
     * Tên đơn vị lữ hành quốc tế
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu đơn vị lữ hành quốc tế
     */
    mo_ta?: string | null;
    /**
     * Chi tiết đơn vị lữ hành quốc tế
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Khu_du_lich {
    /**
     * Tên khu du lịch
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu khu du lịch
     */
    mo_ta?: string | null;
    /**
     * Chi tiết khu du lịch
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Diem_du_lich {
    /**
     * Tên điểm du lịch
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm du lịch
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm du lịch
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Diem_mua_sam {
    /**
     * Tên điểm mua sắm
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu điểm mua sắm
     */
    mo_ta?: string | null;
    /**
     * Chi tiết điểm mua sắm
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Co_quan_nha_nuoc {
    /**
     * Tên cơ quan quản lý nhà nước
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu cơ quan quản lý nhà nước
     */
    mo_ta?: string | null;
    /**
     * Chi tiết cơ quan quản lý nhà nước
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Dich_vu_khac {
    /**
     * Tên dịch vụ khác
     */
    ten?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Giới thiệu dịch vụ khác
     */
    mo_ta?: string | null;
    /**
     * Chi tiết dịch vụ khác
     */
    chi_tiet?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Link_dich_vu {
    /**
     * id của dịch vụ
     */
    id?: IdValue | null;
    /**
     * Tên dịch vụ
     */
    link?: string | null;
}

export interface Tv_dich_vu_cho_duyet_Link_mang_xa_hoi {
    /**
     * Tên mạng xã hội
     */
    name?: string | null;
    /**
     * Link liên kết mạng xã hội
     */
    link?: string | null;
}

export interface Tv_dich_vu_cho_duyet$CustomMethodResource {
    approvedDichVuAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
defineAsyncResource<Tv_dich_vu_cho_duyet>({"name":"tv_dich_vu_cho_duyet","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_approvedDichVu":{}},"views":{}}, mushroom);

export interface Tv_dich_vu_am_thuc {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Tên tiếng việt
     */
    ten_vi?: string | null;
    /**
     * Tên tiếng anh
     */
    ten_en?: string | null;
    /**
     * Thứ tự hiển thị
     */
    thu_tu?: number | null;
    /**
     * Hết hiệu lực. true - hết hiệu lực, false - còn hiệu lực
     */
    het_hieu_luc?: boolean | null;
}

defineAsyncResource<Tv_dich_vu_am_thuc>({"name":"tv_dich_vu_am_thuc","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Tv_gioi_thieu {
    id?: IdValue | null;
    /**
     * Tiêu đề giới thiệu
     */
    tieu_de?: string | null;
    /**
     * Ảnh hiển thị của giới thiệu
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Nội dung của giới thiệu
     */
    noi_dung?: Array<Tv_gioi_thieu_Noi_dung | null | undefined> | null;
    /**
     * Người tạo
     */
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian tạo
     */
    thoi_gian_tao?: ISODateValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    /**
     * Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng Anh
     */
    ngon_ngu?: string | null;
}

export interface Tv_gioi_thieu_Noi_dung {
    /**
     * Ảnh hiển thị của nội dung
     */
    id?: IdValue | null;
    /**
     * Nội dung hiển thị
     */
    noi_dung?: string | null;
}

defineAsyncResource<Tv_gioi_thieu>({"name":"tv_gioi_thieu","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{}},"views":{}}, mushroom);

export interface Tv_nguon_tin_tuc {
    id?: IdValue | null;
    /**
     * Tên nguồn tin tức
     */
    ten?: string | null;
    /**
     * hien thi
     */
    hien_thi?: boolean | null;
    /**
     * Thời gian tạo bản ghi
     */
    thoi_diem_tao?: ISODateValue | null;
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_diem_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
}

defineAsyncResource<Tv_nguon_tin_tuc>({"name":"tv_nguon_tin_tuc","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Tv_dich_vu_quang_cao {
    id?: IdValue | null;
    /**
     * Vị trí quảng cáo
     */
    man_hinh?: string | null;
    /**
     * Ảnh hiển thị
     */
    anh_hien_thi?: IdValue | null;
    /**
     * Chính sách quảng cáo
     */
    chinh_sach?: string | null;
    /**
     * Giá tiền cho các vị trí
     */
    gia_tien?: Array<Tv_dich_vu_quang_cao_Gia_tien | null | undefined> | null;
    /**
     * Hiển thị
     */
    hien_thi?: boolean | null;
    /**
     * Người tạo
     */
    nguoi_tao?: IdValue | null;
    /**
     * Thời gian tạo
     */
    thoi_gian_tao?: ISODateValue | null;
    /**
     * Thời gian lần sửa bản ghi cuối cùng
     */
    thoi_gian_sua_cuoi?: ISODateValue | null;
    /**
     * Mã người sửa cuối
     */
    nguoi_sua_cuoi?: IdValue | null;
    /**
     * Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng Anh
     */
    ngon_ngu?: string | null;
}

export interface Tv_dich_vu_quang_cao_Gia_tien {
    /**
     * Ảnh hiển thị của nội dung. Vị trí 1, vị trí 2, vị trí 3, vị trí 4, vị trí 5, vị trí 6
     */
    vi_tri?: string | null;
    /**
     * Giá tiền vị trí
     */
    gia_tien?: number | null;
}

defineAsyncResource<Tv_dich_vu_quang_cao>({"name":"tv_dich_vu_quang_cao","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{}},"views":{}}, mushroom);

export interface Tv_danh_gia {
    id?: IdValue | null;
    /**
     * Mã người đánh giá
     */
    nguoi_danh_gia_id?: IdValue | null;
    /**
     * Thời điểm phản hồi
     */
    thoi_diem_danh_gia?: ISODateValue | null;
    /**
     * Đối tượng bị đánh giá
     */
    doi_tuong_danh_gia_id?: IdValue | null;
    /**
     * Mã đánh giá cha
     */
    danh_gia_id?: IdValue | null;
    /**
     * min: 1, max: 5 Số sao đánh giá của người dùng
     */
    gia_tri?: number | null;
    /**
     * Nội dung phản hồi
     */
    noi_dung?: string | null;
    /**
     * Cho phép có hiển thị không
     */
    hien_thi?: boolean | null;
    /**
     * Có khóa đánh giá không
     */
    lock?: boolean | null;
    /**
     * Lưu thông tin thêm của từng đánh giá
     */
    thong_tin_them?: Tv_danh_gia_Thong_tin_them | null;
}

export interface Tv_danh_gia_Thong_tin_them {
    /**
     * Thông tin file đính kèm
     */
    media?: Array<IdValue | null | undefined> | null;
}

export interface Tv_danh_gia$CustomMethodResource {
    getStarAsync: (request: MushroomRequest) => Promise<MushroomResponse<any>>;
}
export interface Tv_danh_gia$ViewsResource_suggest_response_userView_OfficerParameters {
    /**
     * Tên người đánh giá
     */
    name?: string | null;
};
export interface Tv_danh_gia$ViewsResource_suggest_response_dichvuView_OfficerParameters {
    /**
     * Tên bài đăng dịch vụ
     */
    name?: string | null;
};
export interface Tv_danh_gia$ViewsResource_suggest_response_card_numberView_Parameters {
    /**
     * Số thẻ hoặc số điện thoại
     */
    filter?: string | null;
    /**
     * Đối tượng đánh giá id
     */
    doi_tuong_danh_gia_id: IdValue;
};
export interface Tv_danh_gia$ViewsResource_get_danh_giaView_Parameters {
    /**
     * Đối tượng đánh giá Id
     */
    doi_tuong_danh_gia_id: string;
    /**
     * Trạng thái trả về. True: Lấy về đánh giá không có trả lời, False: Lấy về đánh giá có trả lời
     */
    status?: boolean | null;
    /**
     * Người đánh giá Id
     */
    nguoi_danh_gia_id?: string | null;
    /**
     * Số lượng bản ghi bỏ qua ở đầu danh sách
     */
    skip?: number | null;
    /**
     * Số lượng tối đa bản ghi trả về
     */
    limit?: number | null;
};
export interface Tv_danh_gia$ViewsResource {
    views: {
        suggest_response_userAsync: MushroomViewFunction<any, Tv_danh_gia$ViewsResource_suggest_response_userView_OfficerParameters>;
        suggest_response_dichvuAsync: MushroomViewFunction<any, Tv_danh_gia$ViewsResource_suggest_response_dichvuView_OfficerParameters>;
        suggest_response_card_numberAsync: MushroomViewFunction<any, Tv_danh_gia$ViewsResource_suggest_response_card_numberView_Parameters>;
        get_danh_giaAsync: MushroomViewFunction<any, Tv_danh_gia$ViewsResource_get_danh_giaView_Parameters>;
    }
}
defineAsyncResource<Tv_danh_gia>({"name":"tv_danh_gia","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"createOne":{},"updatePartially":{},"deleteOne":{},"_raw_http_method_getStar":{}},"views":{"suggest_response_user":{"clientCache":true},"suggest_response_dichvu":{"clientCache":true},"suggest_response_card_number":{"clientCache":true},"get_danh_gia":{"clientCache":true}}}, mushroom);

export interface Map_item {
    /**
     * Mã điểm
     */
    id?: IdValue | null;
    /**
     * Tên địa điểm
     */
    ten_dia_diem?: string | null;
    /**
     * Mã điểm đến
     */
    ma_dia_diem?: string | null;
    /**
     * Loại địa điểm
     */
    loai_dia_diem?: string | null;
    /**
     * Địa chỉ đầy đủ
     */
    dia_chi?: string | null;
    /**
     * Mã tỉnh
     */
    provinceId?: IdValue | null;
    /**
     * Mã huyện
     */
    districtId?: IdValue | null;
    /**
     * Mã xã
     */
    communeId?: IdValue | null;
    /**
     * Tọa độ
     */
    toa_do?: Map_item_Toa_do | null;
    ngay_danh_gia_cuoi?: ISODateValue | null;
    /**
     * Xếp loại an toàn: 1 - An toàn; 2 - Có nguy cơ; 3 - Không an toàn; NULL - Chưa đánh giá
     */
    xep_loai_cuoi?: number | null;
    /**
     * Xếp loại an toàn ngày hôm nay: 1 - An toàn; 2 - Có nguy cơ; 3 - Không an toàn; NULL - Chưa đánh giá ngày hôm nay
     */
    xep_loai_ngay?: number | null;
    /**
     * Dữ liệu nguồn
     */
    nguon?: Map_item_Nguon | null;
    /**
     * Thời điểm cập nhật cuối cùng
     */
    cap_nhat_cuoi?: ISODateValue | null;
}

export interface Map_item_Toa_do {
    /**
     * Kinh độ
     */
    kinh_do?: number | null;
    /**
     * Vĩ độ
     */
    vi_do?: number | null;
}

export interface Map_item_Nguon {
    maphuongxa?: string | null;
    maquanhuyen?: string | null;
    matinh?: string | null;
    phuongxa?: string | null;
    quanhuyen?: string | null;
    tinh?: string | null;
    sonha?: string | null;
}

defineAsyncResource<Map_item>({"name":"map_item","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"updatePartially":{}},"views":{}}, mushroom);

export interface Tv_uu_dai {
    id?: IdValue | null;
    /**
     * Tên ưu đãi
     */
    ten?: string | null;
    /**
     * Hiển thị
     */
    hien_thi?: boolean | null;
    /**
     * Id hình ảnh
     */
    image_id?: IdValue | null;
    /**
     * Loại dịch vụ. Tour, Lưu trú, Ẩm thực, Điểm đến, Giải trí
     */
    dich_vu?: string | null;
    /**
     * Thời gian tạo bản ghi
     */
    thoi_diem_tao?: ISODateValue | null;
}

defineAsyncResource<Tv_uu_dai>({"name":"tv_uu_dai","actions":{"findMany":{"clientCache":true},"findById":{"clientCache":true},"createOne":{}},"views":{}}, mushroom);

export interface File {
    /**
     * Mã file
     */
    id?: IdValue | null;
    /**
     * Tên file
     */
    name?: string | null;
    /**
     * Phần mở rộng (đuôi file)
     */
    extension?: string | null;
    /**
     * Dung lượng file (đơn vị byte)
     */
    length?: number | null;
    /**
     * Mã băm md5 của file
     */
    md5?: string | null;
}

defineAsyncResource<File>({"name":"file","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true}},"views":{}}, mushroom);

export interface Dang_ky_chuong_trinh {
    /**
     * Mã tự sinh
     */
    id?: IdValue | null;
    /**
     * Mã người dùng
     */
    user_id?: IdValue | null;
    /**
     * Cho biết có phải đăng ký chưa được duyệt
     */
    chua_duyet?: boolean | null;
    /**
     * Mã công ty lữ hành
     */
    cong_ty_lu_hanh_id?: IdValue | null;
    /**
     * Thời gian tạo
     */
    created_time?: ISODateValue | null;
}

export interface Dang_ky_chuong_trinh_ApproveResult {
}

export interface Dang_ky_chuong_trinh_ApproveRequest {
    /**
     * Id của đăng ký
     */
    id: IdValue;
}

export interface Dang_ky_chuong_trinh_RejectResult {
}

export interface Dang_ky_chuong_trinh_RejectRequest {
    /**
     * Id của đăng ký
     */
    id: IdValue;
}

export interface Dang_ky_chuong_trinh_Verify_license_noResult {
    /**
     * Danh sách các doanh nghiệp có giấy phép kinh doanh thỏa mãn
     */
    danh_sach_doanh_nghiep: Array<Dang_ky_chuong_trinh_Verify_license_noResult_Danh_sach_doanh_nghiep>;
}

export interface Dang_ky_chuong_trinh_Verify_license_noResult_Danh_sach_doanh_nghiep {
    /**
     * Mã doanh nghiệp
     */
    id: string;
    /**
     * Tên doanh nghiệp
     */
    ten: Dang_ky_chuong_trinh_Verify_license_noResult_Danh_sach_doanh_nghiep_Ten;
    /**
     * Đã đăng ký chương trình hay chưa
     */
    dang_ky: boolean;
}

export interface Dang_ky_chuong_trinh_Verify_license_noResult_Danh_sach_doanh_nghiep_Ten {
    /**
     * Tên doanh nghiệp tiếng Việt
     */
    vi: string;
    /**
     * Tên doanh nghiệp tiếng Anh
     */
    en: string;
}

export interface Dang_ky_chuong_trinh_Verify_license_noRequest {
    /**
     * Số giấy phép kinh doanh
     */
    licenseNo: string;
}

export interface Dang_ky_chuong_trinh_Request_otpResult {
}

export interface Dang_ky_chuong_trinh_Request_otpRequest {
    /**
     * Id của doanh nghiệp
     */
    doanh_nghiep_id: IdValue;
    /**
     * Số điện thoại
     */
    phoneNumber: string;
}

export interface Dang_ky_chuong_trinh_Verify_otpResult {
    /**
     * Tài khoản
     */
    account: string;
    /**
     * Mật khẩu
     */
    password: string;
}

export interface Dang_ky_chuong_trinh_Verify_otpRequest {
    /**
     * Id của doanh nghiệp
     */
    doanh_nghiep_id: IdValue;
    /**
     * Mã OTP
     */
    otp: string;
}

export interface Dang_ky_chuong_trinh$CustomMethodResource {
    approveAsync: (request: CustomMethodBodyRequest<Dang_ky_chuong_trinh_ApproveRequest>) => Promise<MushroomResponse<Dang_ky_chuong_trinh_ApproveResult>>;
    rejectAsync: (request: CustomMethodBodyRequest<Dang_ky_chuong_trinh_RejectRequest>) => Promise<MushroomResponse<Dang_ky_chuong_trinh_RejectResult>>;
    verify_license_noAsync: (request: CustomMethodBodyRequest<Dang_ky_chuong_trinh_Verify_license_noRequest>) => Promise<MushroomResponse<Dang_ky_chuong_trinh_Verify_license_noResult>>;
    request_otpAsync: (request: CustomMethodBodyRequest<Dang_ky_chuong_trinh_Request_otpRequest>) => Promise<MushroomResponse<Dang_ky_chuong_trinh_Request_otpResult>>;
    verify_otpAsync: (request: CustomMethodBodyRequest<Dang_ky_chuong_trinh_Verify_otpRequest>) => Promise<MushroomResponse<Dang_ky_chuong_trinh_Verify_otpResult>>;
}
export interface Dang_ky_chuong_trinh$ViewsResource_danh_sach_doanh_nghiepView_TichHop_QuanLyChuongTrinhParameters {
    /**
     * Số lượng bản ghi cần lấy
     */
    limit?: number | null;
    /**
     * Số lượng bản ghi bỏ qua
     */
    offset?: number | null;
};
export interface Dang_ky_chuong_trinh$ViewsResource_danh_sach_doanh_nghiepView_TichHop_QuanLyChuongTrinhResult {
}

export interface Dang_ky_chuong_trinh$ViewsResource_danh_sach_tourView_TichHop_QuanLyChuongTrinhParameters {
    /**
     * Mã công ty lữ hành
     */
    doanh_nghiep_id?: IdValue | null;
    /**
     * Ngôn ngữ
     */
    lang?: string[] | null;
    /**
     * Số lượng bản ghi cần lấy
     */
    limit?: number | null;
    /**
     * Số lượng bản ghi bỏ qua
     */
    offset?: number | null;
};
export interface Dang_ky_chuong_trinh$ViewsResource_danh_sach_tourView_TichHop_QuanLyChuongTrinhResult {
}

export interface Dang_ky_chuong_trinh$ViewsResource {
    views: {
        danh_sach_doanh_nghiepAsync: MushroomViewFunction<Dang_ky_chuong_trinh$ViewsResource_danh_sach_doanh_nghiepView_TichHop_QuanLyChuongTrinhResult, Dang_ky_chuong_trinh$ViewsResource_danh_sach_doanh_nghiepView_TichHop_QuanLyChuongTrinhParameters>;
        danh_sach_tourAsync: MushroomViewFunction<Dang_ky_chuong_trinh$ViewsResource_danh_sach_tourView_TichHop_QuanLyChuongTrinhResult, Dang_ky_chuong_trinh$ViewsResource_danh_sach_tourView_TichHop_QuanLyChuongTrinhParameters>;
    }
}
defineAsyncResource<Dang_ky_chuong_trinh>({"name":"dang_ky_chuong_trinh","actions":{"findMany":{"clientCache":true,"includeTotal":true},"findById":{"clientCache":true},"deleteOne":{},"_raw_http_method_approve":{},"_raw_http_method_reject":{},"_raw_http_method_verify_license_no":{},"_raw_http_method_request_otp":{},"_raw_http_method_verify_otp":{}},"views":{"danh_sach_doanh_nghiep":{"clientCache":true},"danh_sach_tour":{"clientCache":true}}}, mushroom);


mushroom.$using(config.hostApiTrangVang + "api/v1/");

(function(){
/* using all mushroom extensions */
AuthExtension.useAuth(AuthExtension.AuthLocalStorage, mushroom);
FileExtension.useFile(mushroom);
})();

export interface IApi extends IMushroom {
    /**
     * Thông tin tài khoản
     */
    user: MushroomResourceBase & MushroomListResource<User> & MushroomCountResource & MushroomFindByIdResource<User> & MushroomCreateResource<User> & MushroomPartialUpdateResource<User> & User$CustomMethodResource,
    tv_lien_he: MushroomResourceBase & MushroomListResource<Tv_lien_he> & MushroomCountResource & MushroomFindByIdResource<Tv_lien_he> & MushroomCreateResource<Tv_lien_he> & MushroomPartialUpdateResource<Tv_lien_he> & MushroomDeleteResource,
    /**
     * Thông tin chung của người dùng
     */
    profile: MushroomResourceBase & MushroomListResource<Profile> & MushroomCountResource & MushroomFindByIdResource<Profile> & MushroomPartialUpdateResource<Profile>,
    tv_quang_cao: MushroomResourceBase & MushroomListResource<Tv_quang_cao> & MushroomCountResource & MushroomFindByIdResource<Tv_quang_cao> & MushroomCreateResource<Tv_quang_cao> & MushroomPartialUpdateResource<Tv_quang_cao> & MushroomDeleteResource,
    diem_den_an_toan: MushroomResourceBase & MushroomListResource<Diem_den_an_toan> & MushroomCountResource & MushroomFindByIdResource<Diem_den_an_toan> & Diem_den_an_toan$CustomMethodResource,
    /**
     * Lượt check in của khách tại các điểm đến an toàn
     */
    diem_den_an_toan_check_in: MushroomResourceBase & MushroomListResource<Diem_den_an_toan_check_in> & MushroomCountResource & MushroomFindByIdResource<Diem_den_an_toan_check_in>,
    tv_dich_vu_tour: MushroomResourceBase & MushroomListResource<Tv_dich_vu_tour> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu_tour> & MushroomCreateResource<Tv_dich_vu_tour> & MushroomPartialUpdateResource<Tv_dich_vu_tour> & MushroomDeleteResource & Tv_dich_vu_tour$CustomMethodResource,
    tv_dich_vu_tour_cho_duyet: MushroomResourceBase & MushroomListResource<Tv_dich_vu_tour_cho_duyet> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu_tour_cho_duyet> & MushroomCreateResource<Tv_dich_vu_tour_cho_duyet> & MushroomPartialUpdateResource<Tv_dich_vu_tour_cho_duyet> & MushroomDeleteResource & Tv_dich_vu_tour_cho_duyet$CustomMethodResource,
    tv_tin_tuc: MushroomResourceBase & MushroomListResource<Tv_tin_tuc> & MushroomCountResource & MushroomFindByIdResource<Tv_tin_tuc> & MushroomCreateResource<Tv_tin_tuc> & MushroomPartialUpdateResource<Tv_tin_tuc> & MushroomDeleteResource & Tv_tin_tuc$CustomMethodResource,
    tv_phan_hoi: MushroomResourceBase & MushroomListResource<Tv_phan_hoi> & MushroomCountResource & MushroomFindByIdResource<Tv_phan_hoi> & MushroomCreateResource<Tv_phan_hoi> & MushroomPartialUpdateResource<Tv_phan_hoi> & MushroomDeleteResource,
    /**
     * Thông tin khách du lịch
     */
    khach_du_lich: MushroomResourceBase & MushroomListResource<Khach_du_lich> & MushroomCountResource & MushroomFindByIdResource<Khach_du_lich> & MushroomPartialUpdateResource<Khach_du_lich>,
    /**
     * Dữ liệu tỉnh, thành phố
     */
    province: MushroomResourceBase & MushroomListResource<Province> & MushroomCountResource & MushroomFindByIdResource<Province>,
    /**
     * Dữ liệu quận, huyện, thị xã
     */
    district: MushroomResourceBase & MushroomListResource<District> & MushroomCountResource & MushroomFindByIdResource<District>,
    /**
     * Danh mục phường, xã
     */
    commune: MushroomResourceBase & MushroomListResource<Commune> & MushroomFindByIdResource<Commune>,
    /**
     * Công ty lữ hành
     */
    cong_ty_lu_hanh: MushroomResourceBase & MushroomListResource<Cong_ty_lu_hanh> & MushroomCountResource & MushroomFindByIdResource<Cong_ty_lu_hanh> & Cong_ty_lu_hanh$CustomMethodResource,
    /**
     * Công ty lữ hành
     */
    tv_cong_ty_lu_hanh: MushroomResourceBase & MushroomListResource<Tv_cong_ty_lu_hanh> & MushroomCountResource & MushroomFindByIdResource<Tv_cong_ty_lu_hanh> & Tv_cong_ty_lu_hanh$CustomMethodResource,
    tv_info_diem_den: MushroomResourceBase & MushroomListResource<Tv_info_diem_den> & MushroomCountResource & MushroomFindByIdResource<Tv_info_diem_den> & MushroomCreateResource<Tv_info_diem_den> & MushroomPartialUpdateResource<Tv_info_diem_den> & MushroomDeleteResource,
    tv_info_ve_dien_tu: MushroomResourceBase & MushroomListResource<Tv_info_ve_dien_tu> & MushroomCountResource & MushroomFindByIdResource<Tv_info_ve_dien_tu> & MushroomCreateResource<Tv_info_ve_dien_tu> & MushroomPartialUpdateResource<Tv_info_ve_dien_tu> & MushroomDeleteResource,
    tv_nen_tang_dich_vu: MushroomResourceBase & MushroomListResource<Tv_nen_tang_dich_vu> & MushroomCountResource & MushroomFindByIdResource<Tv_nen_tang_dich_vu> & MushroomCreateResource<Tv_nen_tang_dich_vu> & MushroomPartialUpdateResource<Tv_nen_tang_dich_vu> & MushroomDeleteResource,
    /**
     * Thông báo
     */
    notification: MushroomResourceBase & MushroomListResource<Notification> & MushroomCountResource & MushroomFindByIdResource<Notification> & MushroomCreateResource<Notification> & MushroomPartialUpdateResource<Notification> & MushroomDeleteResource & MushroomBatchDeleteResource,
    tv_don_vi_cung_cap: MushroomResourceBase & MushroomListResource<Tv_don_vi_cung_cap> & MushroomCountResource & MushroomFindByIdResource<Tv_don_vi_cung_cap> & MushroomCreateResource<Tv_don_vi_cung_cap> & MushroomPartialUpdateResource<Tv_don_vi_cung_cap> & MushroomDeleteResource & Tv_don_vi_cung_cap$CustomMethodResource & Tv_don_vi_cung_cap$ViewsResource,
    tv_don_vi_cung_cap_cho_duyet: MushroomResourceBase & MushroomListResource<Tv_don_vi_cung_cap_cho_duyet> & MushroomCountResource & MushroomFindByIdResource<Tv_don_vi_cung_cap_cho_duyet> & MushroomCreateResource<Tv_don_vi_cung_cap_cho_duyet> & MushroomPartialUpdateResource<Tv_don_vi_cung_cap_cho_duyet> & MushroomDeleteResource & Tv_don_vi_cung_cap_cho_duyet$CustomMethodResource,
    tv_dich_vu: MushroomResourceBase & MushroomListResource<Tv_dich_vu> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu> & MushroomCreateResource<Tv_dich_vu> & MushroomPartialUpdateResource<Tv_dich_vu> & MushroomDeleteResource & Tv_dich_vu$CustomMethodResource,
    tv_dich_vu_deleted: MushroomResourceBase & MushroomListResource<Tv_dich_vu_deleted> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu_deleted> & MushroomCreateResource<Tv_dich_vu_deleted> & MushroomPartialUpdateResource<Tv_dich_vu_deleted> & MushroomDeleteResource,
    tv_dich_vu_cho_duyet: MushroomResourceBase & MushroomListResource<Tv_dich_vu_cho_duyet> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu_cho_duyet> & MushroomCreateResource<Tv_dich_vu_cho_duyet> & MushroomPartialUpdateResource<Tv_dich_vu_cho_duyet> & MushroomDeleteResource & Tv_dich_vu_cho_duyet$CustomMethodResource,
    tv_dich_vu_am_thuc: MushroomResourceBase & MushroomListResource<Tv_dich_vu_am_thuc> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu_am_thuc>,
    tv_gioi_thieu: MushroomResourceBase & MushroomListResource<Tv_gioi_thieu> & MushroomCountResource & MushroomFindByIdResource<Tv_gioi_thieu> & MushroomCreateResource<Tv_gioi_thieu> & MushroomPartialUpdateResource<Tv_gioi_thieu>,
    tv_nguon_tin_tuc: MushroomResourceBase & MushroomListResource<Tv_nguon_tin_tuc> & MushroomCountResource & MushroomFindByIdResource<Tv_nguon_tin_tuc> & MushroomCreateResource<Tv_nguon_tin_tuc> & MushroomPartialUpdateResource<Tv_nguon_tin_tuc> & MushroomDeleteResource,
    tv_dich_vu_quang_cao: MushroomResourceBase & MushroomListResource<Tv_dich_vu_quang_cao> & MushroomCountResource & MushroomFindByIdResource<Tv_dich_vu_quang_cao> & MushroomCreateResource<Tv_dich_vu_quang_cao> & MushroomPartialUpdateResource<Tv_dich_vu_quang_cao> & MushroomDeleteResource,
    tv_danh_gia: MushroomResourceBase & MushroomListResource<Tv_danh_gia> & MushroomCountResource & MushroomFindByIdResource<Tv_danh_gia> & MushroomCreateResource<Tv_danh_gia> & MushroomPartialUpdateResource<Tv_danh_gia> & MushroomDeleteResource & Tv_danh_gia$CustomMethodResource & Tv_danh_gia$ViewsResource,
    /**
     * Các điểm trên bản đồ
     */
    map_item: MushroomResourceBase & MushroomListResource<Map_item> & MushroomCountResource & MushroomFindByIdResource<Map_item> & MushroomPartialUpdateResource<Map_item>,
    tv_uu_dai: MushroomResourceBase & MushroomListResource<Tv_uu_dai> & MushroomFindByIdResource<Tv_uu_dai> & MushroomCreateResource<Tv_uu_dai>,
    /**
     * Thông tin file
     */
    file: MushroomResourceBase & MushroomListResource<File> & MushroomCountResource & MushroomFindByIdResource<File>,
    dang_ky_chuong_trinh: MushroomResourceBase & MushroomListResource<Dang_ky_chuong_trinh> & MushroomCountResource & MushroomFindByIdResource<Dang_ky_chuong_trinh> & MushroomDeleteResource & Dang_ky_chuong_trinh$CustomMethodResource & Dang_ky_chuong_trinh$ViewsResource,
};

export type Api = /* all mushroom extensions types */AuthExtension.IMushroomAuth & FileExtension.IMushroomFile & IApi;

export default mushroom as unknown as Api;